import jqRequest from '../jqRequest'
import audioUrls from '../urls/audio'

export default {
  // 获取音频详情
  getAudioDetailById(data) {
    return jqRequest.requestWithToken(audioUrls.getAudioDetailById, data);
  },
}